import Footer from "../../components/common/layout/Footer";
import { Breadcrumbs, IntroSection, OtherServices, UIUXIdeas, UIUXServices } from "@/components/features/uiuxDesign";
import SEO from "@/components/common/seo/seo";
import CallToAction from "@/components/common/sections/CallToAction";

export default function AiSolutions() {
    return(
        <div>
            <SEO
                title="UI/UX Design - SAN micron"
                description="Crafting Exceptional User Experiences Innovative UI/UX Design Solutions Transform your digital presence with our expert UI/UX design services, tailored to enhance user satisfaction and engagement."
            />
            <Breadcrumbs />
            <IntroSection />
            <UIUXServices />
            <UIUXIdeas />
            <CallToAction 
                title="Our Distinctive Design Features Innovative Design Techniques"
            />
            <OtherServices />
            <Footer />
        </div>
    );
}